<p-scroll-panel class="h-full">
  <div [formGroup]="form" class="mb-4">
    <div class="flex gap-10">
      <div class="flex-1" style="max-width: 400px">
        <p-fieldset legend="Stamdata">
          <div class="control">
            <label>Navn</label>
            @if (allowEdit()) {
              <input pInputText formControlName="udbyderNavn" />
              @if (
                form.controls['udbyderNavn'].errors &&
                form.controls['udbyderNavn'].touched
              ) {
                <p class="error">Feltet skal udfyldes</p>
              }
            } @else {
              <div>{{ pu().udbyderNavn }}</div>
            }
          </div>
          <div class="control">
            <label>Regnr</label>
            <div class="numbers">{{ pu().pengeinstitut?.regnr }}</div>
          </div>
          <div class="control">
            <label>NavnNr</label>
            <div>{{ pu().pensionsInfoUdbyderNavnNr }}</div>
          </div>
          <div class="control">
            <label>§41 tilladt fra leverandør</label>
            @if (allowEdit()) {
              <div>
                <p-checkbox
                  [binary]="true"
                  formControlName="p41TilladtFraLeverandoer" />
              </div>
            } @else {
              <div>{{ pu().p41TilladtFraLeverandoer | boolean }}</div>
            }
          </div>
          <div class="control">
            <label>Vises i leverandørlisten</label>
            @if (allowEdit()) {
              <div>
                <p-checkbox
                  formControlName="inkluderIleverandoerliste"
                  [binary]="true" />
              </div>
            } @else {
              {{ pu().inkluderIleverandoerliste | boolean }}
            }
          </div>
        </p-fieldset>
      </div>
      <div class="flex-1" style="max-width: 400px">
        <p-fieldset legend="Kontaktinfo">
          <div formGroupName="adresse">
            <div class="control">
              <label>C/O</label>
              @if (allowEdit()) {
                <input pInputText formControlName="conavn" />
              } @else {
                <div>{{ pu().adresse?.conavn }}</div>
              }
            </div>
            <div class="flex gap-4">
              <div class="control flex-1">
                <label>Vejnavn</label>
                @if (allowEdit()) {
                  <input pInputText formControlName="vejnavn" />
                } @else {
                  <div>{{ pu().adresse?.vejnavn }}</div>
                }
              </div>
              <div class="control" style="width: 80px">
                <label>Nummer</label>
                @if (allowEdit()) {
                  <input pInputText formControlName="vejnr" />
                } @else {
                  <div>{{ pu().adresse?.vejnr }}</div>
                }
              </div>
            </div>
            <div class="control">
              <label>Sted</label>
              @if (allowEdit()) {
                <input pInputText formControlName="sted" />
              } @else {
                <div>{{ pu().adresse?.sted }}</div>
              }
            </div>
            <div class="flex gap-4">
              <div class="control" style="width: 100px">
                <label>Postnummer</label>
                @if (allowEdit()) {
                  <input pInputText formControlName="postnr" />
                } @else {
                  <div>{{ pu().adresse?.postnr }}</div>
                }
              </div>
              <div class="control flex-1">
                <label>Bynavn</label>
                @if (allowEdit()) {
                  <input pInputText formControlName="bynavn" />
                } @else {
                  <div>{{ pu().adresse?.bynavn }}</div>
                }
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>
  </div>
  @if (allowEdit()) {
    <p-button label="Gem ændringer" icon="pi pi-save" (click)="onClickSave()" />
  }
</p-scroll-panel>
<p-dialog
  header="Gem ændringer"
  [modal]="true"
  [(visible)]="showSaveDialog"
  [style]="{ width: '25rem' }">
  <div class="control">
    <label for="username">Kommentar</label>
    <textarea
      [(ngModel)]="kommentar"
      pTextarea
      id="username"
      autocomplete="off"></textarea>
  </div>
  <div class="flex justify-end gap-2">
    <p-button
      label="Gem"
      (click)="saveChanges()"
      [disabled]="!saveDialogIsValid()"
      icon="pi pi-save"
      [loading]="saving()" />
  </div>
</p-dialog>
